import { render, staticRenderFns } from "./SafetyProgramList.vue?vue&type=template&id=2bd61870"
import script from "./SafetyProgramList.vue?vue&type=script&lang=js"
export * from "./SafetyProgramList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports